export const SIDEBAR_PANEL_WIDTH = 220;

export const sidebarPanelStyle = {
  width: `${SIDEBAR_PANEL_WIDTH}px`,
  boxSizing: 'border-box',
};
